<template>
  <div>
    <div class="post-wrap">
      <div class="post-content">
        <div class="post-header">
          <h1>{{currentPost.title}}</h1>
          <span class="post-time">{{currentPost.date | moment}}</span>
        </div>
        <router-view :key="key" />
      </div>
    </div>
    <div class="suggestion-notice">延伸阅读 ...</div>
    <div class="suggestion-cell">
      <div
        class="suggestion"
        v-for="suggetion in suggetions"
        :key="suggetion.name"
        @click="handlePostLink(suggetion)"
      >
        <div
          class="suggestion-header"
          :style="`background: url(${suggetion.coverimg})`"
        >
        </div>
        <div class="suggestion-info">
          <div class="suggestion-title">{{suggetion.title}}</div>
        </div>
        <div class="suggestion-tags">
          <span
            v-for="(tag,index) in suggetion.tags"
            :key={index}
            v-if="index <= 2"
          >{{tag}}</span>
        </div>
      </div>
    </div>
    <div id="dolldiscussion"></div>
  </div>
</template>
<script>
import "highlight.js/styles/atom-one-dark.css";
import { postData } from "../utils/data.js";
import moment from "moment";
const config = require("../../config/");
export default {
  name: "Post",
  data() {
    return {
      index: this.$route.query.index,
      currentPost: {},
      suggetions: [],
      allPosts: JSON.parse(postData)
    };
  },
  computed: {
    key() {
      return this.$route.query.index !== undefined
        ? this.$route.query.index + new Date()
        : 0 + new Date();
    }
  },
  mounted() {
    this.utterances();
  },

  created() {
    let index = this.allPosts.findIndex(item => {
      return item.name === this.$route.path.split("/")[2];
    });
    this.currentPost = this.allPosts[index];
    let suggestionIndexs = [
      this.randomIndex(this.allPosts.length, 0),
      this.randomIndex(this.allPosts.length, 0),
      this.randomIndex(this.allPosts.length, 0)
    ];
    this.suggetions = this.allPosts.filter((post, index) => {
      return suggestionIndexs.includes(index);
    });
  },
  methods: {
    randomIndex(m, n) {
      return Math.round(Math.random() * (m - n) + n);
    },
    handlePostLink: function(post, dir = "post") {
      let { name: postName } = post;
      this.$router.push(`/${dir}/${postName}`);
    },
    utterances: function() {
      var discussion = document.getElementById("dolldiscussion");
      if (!discussion) {
        return;
      }
      if (!config.comments.repo) {
        return;
      }
      var script = document.createElement("script");
      script.src = "https://utteranc.es/client.js";
      script.setAttribute("repo", config.comments.repo);
      script.setAttribute("theme", config.comments.theme);
      script.setAttribute("issue-term", `${this.currentPost.title}`);
      script.setAttribute("crossorigin", "anonymous");
      discussion.appendChild(script);
    }
  },
  filters: {
    moment: function(date) {
      return moment(date).format("MMMM Do YYYY");
    }
  },
  watch: {
    $route(to, from) {
      let index = this.allPosts.findIndex(item => {
        return item.name === this.$route.path.split("/")[2];
      });
      this.currentPost = this.allPosts[index];
      let suggestionIndexs = [
        this.randomIndex(this.allPosts.length, 0),
        this.randomIndex(this.allPosts.length, 0),
        this.randomIndex(this.allPosts.length, 0)
      ];
      this.suggetions = this.allPosts.filter((post, index) => {
        return suggestionIndexs.includes(index);
      });
    }
  }
};
</script>

<style scoped lang="scss">
.test {
  background: url(https://i.loli.net/2019/02/15/5c66387398d29.jpg);
  background-size: cover;
}
.suggestion-notice {
  font-size: 20px;
  line-height: 1.4;
  color: #989797;
  text-align: center;
  margin: 0 auto;
  max-width: 1000px;
  padding-left: 150px;
  padding-right: 150px;
  margin-bottom: 30px;
}

.suggestion-cell {
  display: flex;
  justify-content: space-evenly;
  margin: 0 auto;
  max-width: 1000px;
  padding-left: 150px;
  padding-right: 150px;
  margin-bottom: 30px;
  align-items: center;
}
.suggestion-cell .suggestion {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 32%;
  transition: all 0.2s ease-in-out;
  border-radius: calc(0.25rem - 1px);
  cursor: pointer;
  height: 320px;
  box-shadow: 0px 7px 32px -18px #000;
}
.suggestion .suggestion-info {
  padding: 0.5rem;
}
.suggestion-info .suggestion-title {
  text-align: left;
  font-size: 0.9rem;
  font-weight: 600;
  color: #e94691c9;
}
.suggestion .suggestion-tags {
  padding: 0.5rem;
  text-align: left;
  display: flex;
  justify-content: space-evenly;
}
.suggestion .suggestion-header {
  width: 100%;
  height: 200px;
  background-size: cover !important;
  border-radius: calc(0.25rem - 1px);
}
.suggestion .suggestion-header img {
  border-radius: calc(0.25rem - 1px);
  width: 100%;
}
.suggestion-cell .suggestion:hover {
  box-shadow: 0 18px 32px -18px #000;
  transform: translateY(-6px);
}
.post-header {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.post-header > h1 {
  cursor: pointer;
}
.post-header > h1:hover {
  color: #42b983;
}
.post-time {
  text-align: left;
  letter-spacing: 2px;
  color: #00000078;
  cursor: pointer;
}
.post-time:hover {
  color: #42b983;
}
.post-wrap {
  display: flex;
  margin: 6rem 6rem 0px 6rem;
  border-radius: 2px;
  justify-content: center;
  .post-content {
    display: flex;
    flex-direction: column;
    overflow: hidden;
    max-width: 1000px;
    background: #ffffff94;
    padding-left: 150px;
    padding-right: 150px;
    padding-top: 50px;
    border-radius: 10px;
  }
}
.comments {
  display: flex;
  margin: 2rem 6rem 0px 6rem;
  border-radius: 2px;
  justify-content: center;
  #disqus_thread {
    width: 100%;
    max-width: 1000px;
    padding-top: 50px;
    border-radius: 10px;
  }
}

.widget-title {
  margin: 0 auto;
  height: 40px;
  width: 80%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.line {
  height: 1px;
  flex-grow: 1;
  background-color: #dfdfdf;
}
.widget-title .title-text {
  margin: 0 2rem;
  color: #9a9a9a;
  letter-spacing: 1rem;
}
.footer {
  display: flex;
  justify-content: space-around;
  margin: 2rem 6rem;
}
.previous,
.next {
  width: 50%;
  display: flex;
}
.next {
  justify-content: flex-end;
}
.previous {
  margin-left: 0rem;
}
.previous span {
  line-height: 24px;
  margin-left: 2rem;
  color: #00000078;
  cursor: pointer;
}
.next span {
  line-height: 24px;
  margin-right: 2rem;
  color: #00000078;
  cursor: pointer;
}

.previous:hover span,
.next:hover span {
  color: #42b983;
}

.previous:hover .previous-arrow {
  border-right-color: #42b983;
}
.next:hover .next-arrow {
  border-left-color: #42b983;
}

.previous-arrow {
  width: 12px;
  height: 12px;
  border: 12px solid #fff;
  border-right-color: #00000078;
  border-radius: 0px;
}

.next-arrow {
  width: 12px;
  height: 12px;
  border: 12px solid #fff;
  border-left-color: #00000078;
  border-radius: 0px;
}
@media screen and (max-width: 1000px) and (min-width: 300px) {
  .post-wrap {
    margin: 1rem;
  }
  .post-wrap .post-content {
    padding: 0rem;
  }
  .post-header h1 {
    font-size: 1.4rem;
  }
  .post-header .post-time {
    font-size: 1rem;
  }
  .footer {
    margin: 0rem;
    margin-top: 1rem;
    margin-bottom: 2rem;
  }
  .previous span {
    margin-left: 0.5rem;
  }
  .next span {
    margin-right: 0.5rem;
  }
  .post_meta {
    width: 100%;
  }
}

// 小屏不显示评论信息
@media screen and (max-width: 800px) and (min-width: 300px) {
  .comments {
    display: none;
    #disqus_thread {
      display: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Post.vue